module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurSmall/scandal.0d319f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurSmall/scandal.jpg
// module id = PvU2
// module chunks = 0